import React, { useState, useEffect } from 'react';
import styles from './CyclingText.module.css';

const CyclingText = ({ phrases, className = '', interval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setInterval(() => {
            setIsVisible(false);
            
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % phrases.length);
                setIsVisible(true);
            }, 1000); // Short delay for fade out/in effect
            
        }, interval);

        return () => clearInterval(timer);
    }, [phrases.length, interval]);

    return (
        <div 
            className={`${styles.cyclingText} ${className} ${isVisible ? styles.visible : styles.hidden}`}
        >
            <span>{phrases[currentIndex]}</span>
        </div>
    );
};

export default CyclingText;
